module.exports = __webpack_public_path__ + "static/coliving-dining-b6a598effd8e5820c39e3854a710cdae.jpg";